import { render } from "./FeedBackBlock.vue?vue&type=template&id=19282f24&scoped=true"
import script from "./FeedBackBlock.vue?vue&type=script&lang=js"
export * from "./FeedBackBlock.vue?vue&type=script&lang=js"

import "./FeedBackBlock.vue?vue&type=style&index=0&id=19282f24&lang=scss"
import "./FeedBackBlock.vue?vue&type=style&index=1&id=19282f24&lang=scss&scoped=true"

import exportComponent from "/home/romych/projects/vue.home.zina.design/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19282f24"]])

export default __exports__